import styled from 'styled-components';
import { Colors } from '../Style/Colors';

interface ModalFrameProps {
	children?: React.ReactNode;
	size?: 'sm' | 'md' | 'lg' | 'xl' | 'none';
	title?: string | JSX.Element;
	padding?: string;
}

export default function ModalFrame(props: ModalFrameProps) {
	const size = props.size ? props.size : 'none';
	const padding = props.padding ? props.padding : '1rem';

	return (
		<Container size={size}>
			{props.title ? <Title>{props.title}</Title> : null}
			{props.children ? <Content padding={padding}>{props.children}</Content> : null}
		</Container>
	);
}

interface StyleProps {
	size: string;
}

const Content = styled.div<{ padding: string }>`
	padding: ${(props) => props.padding};
	background: ${Colors.gray1};
	font-size: 12px;
	color: ${Colors.dark};
	max-height: 100%;
	overflow-y: auto;
`;

const Title = styled.div`
	padding: 6px 20px;
	color: ${Colors.gray7};
	border-top: 1px solid ${Colors.gray2};
	border-bottom: 2px solid ${Colors.gray4};
	text-decoration: none;
	background-color: ${Colors.gray3};
	font-weight: 700;
	font-size: 14px;
`;

const Container = styled.div<StyleProps>`
	max-height: calc(var(--vh) * 100 - 44px);
	${(props) => {
		let mw, mw_sm;
		switch (props.size) {
			case 'sm':
				mw = '300px';
				mw_sm = '40vw';
				break;
			case 'md':
				mw = '30vw';
				mw_sm = '50vw';
				break;
			case 'lg':
				mw = '60vw';
				mw_sm = '80vw';
				break;
			case 'xl':
				mw = '80vw';
				mw_sm = '100vw';
				break;
			case 'none':
				mw = 'unset';
				mw_sm = 'unset';
				break;
		}
		return `
			min-width: ${mw};
			max-width: ${mw};
			@media(max-width: 1000px) {
				min-width: ${mw_sm};
				max-width: ${mw_sm};
			}
			@media(max-width: 500px) {
				min-width: 100vw;
				max-width: 100vw;
				border-radius: 0;
			}
		`;
	}}
	background: white;
	padding: 0;
	overflow: hidden;
	display: flex;
	flex-direction: column;
	box-shadow: 0px 10px 15px #00000030;
`;
